import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className="footer">
            This app is made by Istiaque Ahmed Arik. API gets from https://corona.lmao.ninja/docs. 
        </div>
    )
}

export default Footer
